import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

const MyNavLink = (props: NavLinkProps) => {
	return (
		<NavLink {...props} />
	);
}
export default MyNavLink;